// U5: what else happens when a holding reply is confirmed, said in the approve strip before the
// press: a task to reply properly by that day, and the thread remembers the promise.
import { useHoldingReply } from "@web/lib/unstickApi";

export function holdingStripWords(phrase: string | null): string {
  return phrase
    ? `Once it's sent, MeeMail makes a task to reply properly by ${phrase} and the thread shows “You said you'd reply by ${phrase}”.`
    : "Once it's sent, MeeMail makes a task to reply properly by the day it names.";
}

export function HoldingStripNote({ cardId }: { cardId: string }) {
  const phrase = useHoldingReply(cardId, true).data?.holding?.phrase ?? null;
  return (
    <p className="text-sm text-ink-2" data-testid="holding-strip-note">
      {holdingStripWords(phrase)}
    </p>
  );
}
